import React from 'react';
import { METRIKA_GOALS, reachGoal } from '../analytics';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <span className="brand-mark">AG</span>
          <span>glotov.pro</span>
        </div>
        <div className="footer-links">
          <a href="https://t.me/glotov_pro" target="_blank" rel="noopener noreferrer">
            Telegram
          </a>
          <a
            href="https://max.ru/join/pai31kNDfQCJk9YR70Yc6iYs1LVh2Jcn5rey-d7I6lA"
            target="_blank"
            rel="noopener noreferrer"
          >
            MAX
          </a>
          <a href="mailto:aleksey@glotov.pro">aleksey@glotov.pro</a>
          <a
            href="https://school.glotov.pro"
            target="_blank"
            rel="noopener noreferrer"
            data-metrika-goal={METRIKA_GOALS.SELECT_SCHOOL}
            onClick={() => reachGoal(METRIKA_GOALS.SELECT_SCHOOL)}
          >
            Школа управления
          </a>
          <a
            href="https://school.glotov.pro/pd-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Политика обработки данных
          </a>
          <button type="button" data-cookie-settings>
            Настройки cookie
          </button>
        </div>
        <div className="footer-legal">
          <p>© {new Date().getFullYear()} Алексей Глотов. Все права защищены.</p>
          <p>ИНН 366222711972 · плательщик НПД</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
